import { useMemo } from 'react';
import { StyledProgressIndicator, ProgressIndicatorWrapper } from './ProgressIndicator.styles';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressIndicator = ({
  totalSteps,
  currentStepNumber,
  shouldHalveProgressBar = false
}) => {
  const currentProgress = useMemo(() => {
    let progress = Math.round(currentStepNumber / (totalSteps + 1) * 100);
    if (shouldHalveProgressBar) {
      progress = progress / 2;
    }
    return progress;
  }, [currentStepNumber, totalSteps, shouldHalveProgressBar]);
  return /*#__PURE__*/_jsx(StyledProgressIndicator, {
    children: /*#__PURE__*/_jsx(ProgressIndicatorWrapper, {
      children: /*#__PURE__*/_jsx(Progress, {
        "aria-label": `Step ${currentStepNumber} of ${totalSteps}`,
        use: "success",
        value: currentProgress
      })
    })
  });
};